import React from 'react';

function BottomNavigation({ activeTab, onTabChange, isAuthenticated }) {
    return (
        <div className="fixed-bottom bg-white border-top">
            <div className="container">
                <div className="d-flex justify-content-around align-items-center position-relative">
                    <button 
                        className={`btn btn-link d-flex flex-column align-items-center ${activeTab === 'loans' ? 'text-primary' : 'text-muted'}`}
                        onClick={() => onTabChange('loans')}
                        disabled={!isAuthenticated}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="bi bi-wallet2 icon-sm"></i>
                        <small>Mis Préstamos</small>
                    </button>

                    {/* Botón Home central */}
                    <button 
                        className={`btn btn-link position-absolute top-0 start-50 translate-middle-x ${activeTab === 'home' ? 'text-primary' : 'text-muted'}`}
                        onClick={() => onTabChange('home')}
                        disabled={!isAuthenticated}
                        style={{ marginTop: '-30px' }}
                    >
                        <div className="icon-circle icon-circle-lg bg-white shadow">
                            <i className="bi bi-house icon-lg"></i>
                        </div>
                    </button>

                    <button 
                        className={`btn btn-link d-flex flex-column align-items-center text-decoration-none ${activeTab === 'payments' ? 'text-primary' : 'text-muted'}`}
                        onClick={() => onTabChange('payments')}
                        disabled={!isAuthenticated}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="bi bi-credit-card icon-sm"></i>
                        <small>Cómo Pagar</small>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default BottomNavigation; 